<template>
  <div>
    <!-- Button -->
    <div class="top-table-container">
      <el-input v-model="search" prefix-icon="el-icon-search" class="search" placeholder="Buscar por palabra clave..." />
      <el-button @click.prevent="formNuevo">Nueva Región</el-button>
    </div>

    <!-- Table -->
    <el-table empty-text="Sin Resultados" :data="regionesData" border style="width: 100%">
      <el-table-column prop="id" width="50" label="ID" align="center"> </el-table-column>
      <el-table-column prop="nombre" label="Nombre" sortable></el-table-column>
      <el-table-column prop="min_metros" align="center" label="Min. Metros" width="120"></el-table-column>
      <el-table-column align="center" prop="esta_vigente" label="Vigente" width="120">
        <template slot-scope="scope">
          <el-tag :type="scope.row.esta_vigente == '1' ? 'success' : 'danger'" disable-tranSitions>
            <template v-if="scope.row.esta_vigente == '1'">{{ "Si" }}</template>
            <template v-else>{{ "No" }}</template>
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="Acciones" width="220" align="center">
        <template slot-scope="scope">
          <el-button size="mini" icon="el-icon-edit" @click.prevent="formEditar(scope.$index, scope.row)">Editar</el-button>
          <el-button size="mini" type="danger" icon="el-icon-delete" @click.prevent="eliminar(scope.$index, scope.row)">Eliminar</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="paginate">
      <el-pagination background layout="prev, pager, next" @current-change="paginate" :page-size="pageSize" :total="total"> </el-pagination>
    </div>

    <!-- Modal => Nuevo - Editar -->
    <el-dialog :title="tituloModal" :visible.sync="modal" width="35%" top="10vh" :close-on-click-modal="false" :close-on-press-escape="false">
      <el-form :model="region" :rules="rules" ref="region" label-position="top">
        <el-row :gutter="16">
          <el-col :span="6">
            <el-form-item prop="id" label="ID" v-show="operacion == 'editar'">
              <el-input :disabled="true" v-model="region.id"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="18">
            <el-form-item label="Nombre" prop="nombre">
              <el-input v-model="region.nombre" placeholder="Nombre de la región"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Cant. Minina de Metros" prop="min_metros">
              <el-input v-model.number="region.min_metros" placeholder="Cant. metros" maxlength="3" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Esta Vigente" v-show="operacion == 'editar'" prop="esta_vigente">
              <el-switch v-model="region.esta_vigente" active-color="#13ce66" inactive-color="#ff4949"> </el-switch>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click.prevent="modal = false">{{ "Cancelar" }}</el-button>
        <el-button v-loading.fullscreen.lock="loading" type="primary" @click.prevent="guardar('region')">{{ accion }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from "@/axios";

export default {
  name: "Regiones",
  data() {
    return {
      modal: false,
      search: "",
      page: 1,
      pageSize: 10,
      total: 0,
      loading: false,
      operacion: "",
      accion: "",
      tituloModal: "",
      regiones: [],
      region: {
        id: "",
        nombre: "",
        min_metros: "",
        esta_vigente: true,
      },
      rules: {
        nombre: [{ required: true, message: "Este campo es requerido.", trigger: "blur" }],
        min_metros: [
          { required: true, message: "Este campo es requerido.", trigger: "blur" },
          { type: "number", message: "El campo metros solo recibe numeros." },
        ],
      },
    };
  },
  created() {
    this.mostrar();
  },
  computed: {
    searching() {
      if (!this.search) {
        this.total = this.regiones.length;
        return this.regiones;
      }
      this.page = 1;
      return this.regiones.filter(data => data.nombre.toLowerCase().includes(this.search.toLowerCase()));
    },
    regionesData() {
      this.total = this.searching.length;
      return this.searching.slice(this.pageSize * this.page - this.pageSize, this.pageSize * this.page);
    },
  },
  methods: {
    // MÉTODOS PARA EL CRUD
    mostrar() {
      axios
        .get("regiones")
        .then(res => (this.regiones = res.data))
        .catch(err => {
          console.log(err);
          this.$notify.error({
            title: "Error",
            dangerouslyUseHTMLString: true,
            message: `No se ha podido mostrar la data, ah ocurrido un error inesperado`,
          });
        });
    },
    crear() {
      const datos = {
        nombre: this.region.nombre,
        min_metros: this.region.min_metros,
        esta_vigente: this.region.esta_vigente,
      };
      axios
        .post("regiones", datos)
        .then(res => {
          if (res) {
            this.loading = true;
            setTimeout(() => {
              this.loading = false;
              this.$notify({
                title: "Éxito",
                dangerouslyUseHTMLString: true,
                message: `<strong>${datos.nombre}</strong> ha sido <strong>creada</strong> con exito!`,
                type: "success",
              });
              this.mostrar();
            }, 1500);
          }
        })
        .catch(err => {
          console.log(err);
          this.$notify.error({
            title: "Error",
            dangerouslyUseHTMLString: true,
            message: `No se ha podido crear la región, ah ocurrido un error inesperado`,
          });
        });
      this.region.nombre = "";
      this.region.min_metros = "";
    },
    editar() {
      const id = this.region.id;
      const datos = {
        nombre: this.region.nombre,
        min_metros: this.region.min_metros,
        esta_vigente: this.region.esta_vigente,
      };
      axios
        .put(`regiones/${id}`, datos)
        .then(res => {
          if (res) {
            this.loading = true;
            setTimeout(() => {
              this.loading = false;
              this.$notify({
                title: "Éxito",
                dangerouslyUseHTMLString: true,
                message: `<strong>${datos.nombre}</strong> ha sido <strong>actualizada</strong> con exito!`,
                type: "success",
              });
              this.mostrar();
            }, 1500);
          }
        })
        .catch(err => {
          console.log(err);
          this.$notify.error({
            title: "Error",
            dangerouslyUseHTMLString: true,
            message: `No se ha podido editar la región, ah ocurrido un error inesperado`,
          });
        });
    },
    eliminar(_, data) {
      const id = data.id;
      this.$confirm("Esta seguro que desea eliminar este registro?", "Eliminar Región", {
        confirmButtonText: "Si",
        cancelButtonText: "Cancelar",
        type: "warning",
      })
        .then(res => {
          if (res) {
            axios
              .delete(`regiones/${id}`)
              .then(res => {
                if (res) {
                  this.loading = true;
                  setTimeout(() => {
                    this.loading = false;
                    this.$notify({
                      title: "Éxito",
                      dangerouslyUseHTMLString: true,
                      message: `<strong>${data.nombre}</strong> ha sido <strong>eliminada</strong> con exito!`,
                      type: "success",
                    });
                    this.mostrar();
                  }, 1500);
                }
              })
              .catch(err => {
                console.log(err);
                this.$notify.error({
                  title: "Error",
                  dangerouslyUseHTMLString: true,
                  message: `No se ha podido eliminar la región, ah ocurrido un error inesperado`,
                });
              });
          }
        })
        .catch(err => console.log(err));
    },
    //Botones y Formularios
    guardar(region) {
      this.$refs[region].validate(valid => {
        if (valid) {
          if (this.operacion == "crear") this.crear();
          if (this.operacion == "editar") this.editar();
          this.modal = false;
          this.$refs[region].resetFields();
        } else {
          return false;
        }
      });
    },
    formNuevo() {
      this.modal = true;
      this.operacion = "crear";
      this.accion = "Guardar";
      this.tituloModal = "Nueva Región";
      this.region.nombre = "";
      this.region.min_metros = "";
      if (typeof this.$refs.region != "undefined") {
        this.$refs.region.resetFields();
      }
    },
    formEditar(_, data) {
      //capturamos los datos del registro seleccionado y los mostramos en el formulario
      this.modal = true;
      this.operacion = "editar";
      this.accion = "Actualizar";
      this.tituloModal = "Editar Región";
      this.region.id = data.id;
      this.region.nombre = data.nombre;
      this.region.min_metros = data.min_metros;
      this.region.esta_vigente = data.esta_vigente == "1" ? true : false;
      if (typeof this.$refs.region != "undefined") {
        this.$refs.region.clearValidate();
      }
    },
    // Paginación
    paginate(val) {
      this.page = val;
    },
  },
};
</script>

<style></style>
